export default "__VITE_ASSET__3de8a121__"